import AboutImg from "../images/about.jpeg";
import Title from "./Title";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";
const About = () => {
  return (
    <section className="section" id="about">
      <Title title="about" subTitle="us" />

      <div className="section-center about-center">
        <div className="about-img">
          <img src={AboutImg} className="about-photo" alt="awesome beach" />
        </div>
        <article className="about-info">
          <h3>explore the difference</h3>
          <p>
            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Aspernatur
            quisquam harum nam cumque temporibus explicabo dolorum sapiente odio
            unde dolor?
          </p>
          <p>
            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Aspernatur
            quisquam harum nam cumque temporibus explicabo dolorum sapiente odio
            unde dolor?
          </p>
          <Button asChild>
            <Link to={{ pathname: "/", hash: "#about" }}>read more</Link>
          </Button>
        </article>
      </div>
    </section>
  );
};
export default About;
